import React from 'react';
import Select from 'react-select';
import {Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';
import FormHelper from '../../form.js';
import Messagev2 from '../../../../config/message_v2.js'; 
import {ButtonValidation, ButtonCancel} from '../../../../component/Button.js'
import { toast } from 'react-toastify';

export default class ModalReportproblem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      Asset       : '',
      Description : '',
      Type        : '',
      is_process  : false,
    }

    this.onReport = this.onReport.bind(this)
    this.onReportSuccess = this.onReportSuccess.bind(this)
    this.onReportFailed = this.onReportFailed.bind(this)
  }

  onReport() {
    if(!FormHelper.validateFormReport(this.state, Messagev2)) {
      return
    }
    this.setState({is_process: true})
    Presenter.RegisterReport(
      RequestProperties.RegisterReport(this, this.onReportSuccess, this.onReportFailed)
    )
  }

  onReportSuccess(params, response) {
    this.setState({
      Type        : "",
      Description : "",
      is_process  : false,
    })
    toast.success(Messagev2.SUCCESS.REGISTRATION)
    this.props.toggleModal();
  }

  onReportFailed(response) {
    this.setState({is_process: false})
    try {
      toast.error(response.data.detail)
    }
    catch(error) {
      console.error(response);
    }
    this.props.toggleModal();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.asset !== '' || nextProps.asset !== null || nextProps.asset !== undefined) {
      this.setState({Asset: nextProps.asset.assetAlias})
    }
  }

  render() {
    const props = this.props;
    const {is_process} = this.state

    return (
      <Modal isOpen={props.modalReportProblem} toggle={()=>props.toggleModal()}>
        <ModalHeader toggle={()=>props.toggleModal()}>Report Problem</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-6">
              <label>Asset/ Tools</label>
              <input type="text" className="form-control" value={decodeURIComponent(props.asset.assetName)} readOnly/>
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Report Type</label>
              <Select
                name="maintenance"
                clearable={false}
                placeholder="Type Report"
                value={this.state.Type}
                onChange={(val) => this.setState({Type: val.value})}
                options={[
                  {value: 'report_broken', label: 'Broken'},
                  {value: 'report_lost', label: 'Lost'}
                ]}
              />
            </div>
            <div className="form-group col-sm-12">
              <label className="required">Description</label>
              <textarea 
                className="form-control" 
                cols="30" rows="3" 
                value={this.state.Description}
                onChange={(e)=>this.setState({Description: e.target.value})}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={()=>props.toggleModal()}>Cancel</ButtonCancel>
          <ButtonValidation is_process={is_process} onClick={()=>this.onReport()} disabled={this.state.disabled}>Report</ButtonValidation>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/Modal/ModalReportproblem.js